import React, {useState} from 'react'
import {KTCard, KTCardBody, KTSVG, QUERIES} from '../../../../../_metronic/helpers'
import {useMutation, useQuery} from 'react-query'
import {fetchLinks} from '../scrapping-table/core/_requests'
import {useQueryClient} from 'react-query'
import {useNavigate} from 'react-router-dom'
import {toast, ToastContainer} from 'react-toastify'

export const useGetFetchQuery = (name: any) => {
  const queryClient = useQueryClient()
  return queryClient.getQueryData(name)
}

interface InputCardProps {
  isCrawling: boolean
  handleCrawlClick: (value: boolean) => void
  setSearchTerm: (value: string) => void
  searchTerm: string
}

const InputCard: React.FC<InputCardProps> = ({isCrawling, handleCrawlClick,setSearchTerm,searchTerm}) => {
  const redirectToRoute = () => {
    navigate(-1)
  } // Replace with the actual route you want to redirect to  };

  const navigate = useNavigate()

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.LINKS_LIST}-`,
    () => {
      return fetchLinks(searchTerm)
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: false}
  )

  const handleCrawlButton = async () => {
    const urlPattern = /^https:\/\//i; // Regular expression to match "https://"
    
    if (searchTerm != null && searchTerm != '') {
      if (urlPattern.test(searchTerm)) {
        handleCrawlClick(true);
        await refetch();
        handleCrawlClick(false);
      } else {
        toast.error('Your website url should start with https');
      }
    } else {
      toast.info('Please input your website url');
    }
  }

  const handleInputKeyDown = async (event:any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default behavior of the Enter key
      handleCrawlButton(); // Call the same function as the button click
    }
  };

  
  return (
    <div className='d-flex flex-column flex-center text-center mt-15'>
      <div className='card card-flush w-lg-950px'>
        <KTCard className='pt-5 pb-5'>
          <KTCardBody className='py-0'>
            <div className='d-flex align-items-center position-relative'>
              <div onClick={redirectToRoute}>
                {' '}
                <KTSVG
                  path='/media/icons/duotune/general/gen001.svg'
                  className='svg-icon-1 me-10'
                />
              </div>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-20'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid ps-18 pt-3 pb-3 me-5'
                placeholder='Website URL'
                value={searchTerm}
                onKeyDown={handleInputKeyDown} // Add this line
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                className='btn btn-md btn-primary'
                onClick={handleCrawlButton}
                disabled={isCrawling}
              >
                {isCrawling ? (
                  <div className='spinner-border spinner-border-sm' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                ) : (
                  'Crawl'
                )}
              </button>
            </div>
          </KTCardBody>
        </KTCard>
      </div>
    </div>
  )
}

export {InputCard}
